/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Bank_Generate_DescriptionInputs */

const en_story_bank_generate_description = /** @type {(inputs: Story_Bank_Generate_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI will analyze your resume and the job description to create tailored STAR+R stories.`)
};

const de_story_bank_generate_description = /** @type {(inputs: Story_Bank_Generate_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI will analyze your resume and the job description to create tailored STAR+R stories.`)
};

const fr_story_bank_generate_description = /** @type {(inputs: Story_Bank_Generate_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI will analyze your resume and the job description to create tailored STAR+R stories.`)
};

const es_story_bank_generate_description = /** @type {(inputs: Story_Bank_Generate_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI will analyze your resume and the job description to create tailored STAR+R stories.`)
};

const it_story_bank_generate_description = /** @type {(inputs: Story_Bank_Generate_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI will analyze your resume and the job description to create tailored STAR+R stories.`)
};

const nl_story_bank_generate_description = /** @type {(inputs: Story_Bank_Generate_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI will analyze your resume and the job description to create tailored STAR+R stories.`)
};

const pl_story_bank_generate_description = /** @type {(inputs: Story_Bank_Generate_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI will analyze your resume and the job description to create tailored STAR+R stories.`)
};

const fi_story_bank_generate_description = /** @type {(inputs: Story_Bank_Generate_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI will analyze your resume and the job description to create tailored STAR+R stories.`)
};

const da_story_bank_generate_description = /** @type {(inputs: Story_Bank_Generate_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI will analyze your resume and the job description to create tailored STAR+R stories.`)
};

const sv_story_bank_generate_description = /** @type {(inputs: Story_Bank_Generate_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI will analyze your resume and the job description to create tailored STAR+R stories.`)
};

/**
* | output |
* | --- |
* | "AI will analyze your resume and the job description to create tailored STAR+R stories." |
*
* @param {Story_Bank_Generate_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const story_bank_generate_description = /** @type {((inputs?: Story_Bank_Generate_DescriptionInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Bank_Generate_DescriptionInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_story_bank_generate_description(inputs)
	if (locale === "fr") return fr_story_bank_generate_description(inputs)
	if (locale === "es") return es_story_bank_generate_description(inputs)
	if (locale === "it") return it_story_bank_generate_description(inputs)
	if (locale === "nl") return nl_story_bank_generate_description(inputs)
	if (locale === "pl") return pl_story_bank_generate_description(inputs)
	if (locale === "fi") return fi_story_bank_generate_description(inputs)
	if (locale === "da") return da_story_bank_generate_description(inputs)
	if (locale === "sv") return sv_story_bank_generate_description(inputs)
	return en_story_bank_generate_description(inputs)
});